var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Configuration_in_cyberspace_for_security._2_",
    "data-name": "Configuration in cyberspace for security. (2)",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M8.7,1.878A.7.7,0,0,1,9.39,1.25H13.11a.7.7,0,0,1,.694.628l.215,2.149a.233.233,0,0,0,.379.158L16.07,2.817a.7.7,0,0,1,.935.047l2.632,2.631a.7.7,0,0,1,.047.936L18.315,8.1a.233.233,0,0,0,.156.379l2.151.214a.7.7,0,0,1,.628.695V13.11a.7.7,0,0,1-.628.694l-2.15.215a.233.233,0,0,0-.157.379l1.367,1.672a.7.7,0,0,1-.047.936l-2.631,2.631a.7.7,0,0,1-.935.047L14.4,18.315a.233.233,0,0,0-.38.156l-.214,2.151a.7.7,0,0,1-.695.628H9.39a.7.7,0,0,1-.694-.628l-.215-2.151a.233.233,0,0,0-.379-.156L6.43,19.683a.7.7,0,0,1-.935-.047L2.863,17.005a.7.7,0,0,1-.047-.935L4.184,14.4a.233.233,0,0,0-.156-.379l-2.149-.214a.7.7,0,0,1-.629-.695V9.39A.7.7,0,0,1,1.878,8.7l2.151-.215A.233.233,0,0,0,4.185,8.1L2.817,6.43a.7.7,0,0,1,.047-.936L5.495,2.863a.7.7,0,0,1,.935-.047L8.1,4.184a.233.233,0,0,0,.379-.156l.214-2.149Zm1.326.767L9.869,4.166a1.628,1.628,0,0,1-2.651,1.1L6.035,4.3,4.3,6.034l.968,1.184a1.628,1.628,0,0,1-1.1,2.651l-1.522.152v2.458l1.521.153a1.628,1.628,0,0,1,1.1,2.651L4.3,16.465,6.035,18.2l1.183-.968a1.628,1.628,0,0,1,2.651,1.1l.152,1.522h2.458l.153-1.522a1.628,1.628,0,0,1,2.651-1.1l1.182.967L18.2,16.465l-.967-1.183a1.628,1.628,0,0,1,1.1-2.651l1.521-.152V10.022L18.333,9.87a1.628,1.628,0,0,1-1.1-2.651L18.2,6.035,16.465,4.3l-1.183.967a1.628,1.628,0,0,1-2.651-1.1l-.152-1.521H10.022Z",
    transform: "translate(0 0)",
    fill: "#280f0b",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M11.669,8.645a3.023,3.023,0,1,0,3.023,3.023A3.023,3.023,0,0,0,11.669,8.645ZM7.25,11.669a4.419,4.419,0,1,1,4.419,4.419A4.419,4.419,0,0,1,7.25,11.669Z",
    transform: "translate(-0.419 -0.419)",
    fill: "#280f0b",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.a3468fd985022633cba64cb8ba426a55.svg";
export { ForwardRef as ReactComponent };